import type { FC, InputHTMLAttributes } from 'react';

import cn from 'classnames';

type PillTextInputProps = InputHTMLAttributes<HTMLInputElement>;

export const PillTextInput: FC<PillTextInputProps> = ({ className, ...props }) => (
  <input
    className={cn(
      // 16px base avoids iOS focus zoom; 13px design restored at sm+.
      'h-12 w-full rounded-full border border-black/10 bg-black/5 px-4 text-[16px] font-medium leading-4 tracking-[-0.13px] text-black outline-none ring-0 placeholder:text-black/30 sm:text-[13px] sm:focus:text-[13px]',
      'transition-colors duration-150 hover:border-black/20 focus:border-black/30 focus:bg-black/[0.07]',
      className,
    )}
    {...props}
  />
);
